import React from 'react';

// import icons
import IconShapes from 'js/components/icon/Icon.shapes';

const SectionPageWrapper = ({ className = '', bgColor = '#8FCCF1', children }) => {
  return (
    <div className={'page ' + className} style={{ height: '100%' }}>
      <div className="container--inner" style={{ backgroundColor: bgColor }}>
        <IconShapes className="icon-shapes" />
        {children}
      </div>
    </div>
  );
};

export default SectionPageWrapper;
